'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _dec3, _dec4, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _recompose = require('recompose');

var _milanoteForm = require('../../../components/form/milanoteForm');

var _milanoteForm2 = _interopRequireDefault(_milanoteForm);

var _LoadingTransitionDisplay = require('../../../components/loaders/LoadingTransitionDisplay');

var _LoadingTransitionDisplay2 = _interopRequireDefault(_LoadingTransitionDisplay);

var _PaymentForm = require('./form/PaymentForm');

var _PaymentForm2 = _interopRequireDefault(_PaymentForm);

var _PaymentProcessing = require('./processing/PaymentProcessing');

var _PaymentProcessing2 = _interopRequireDefault(_PaymentProcessing);

var _PaymentSuccess = require('./success/PaymentSuccess');

var _PaymentSuccess2 = _interopRequireDefault(_PaymentSuccess);

var _planEnquiryAnalyticsService = require('../plan/planEnquiryAnalyticsService');

var _userUtil = require('../../userUtil');

var _timeUtil = require('../../../../common/utils/timeUtil');

var _paymentActions = require('./paymentActions');

var _paymentSelector = require('./paymentSelector');

var _paymentConstants = require('./paymentConstants');

require('./Payment.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchLoadPlans: function dispatchLoadPlans(volume) {
            return dispatch((0, _paymentActions.loadPlans)({ volume: volume }));
        },
        dispatchClearCard: function dispatchClearCard() {
            return dispatch((0, _paymentActions.clearPrefilledCard)());
        },
        dispatchFetchCoupon: function dispatchFetchCoupon(couponCode) {
            return dispatch((0, _paymentActions.fetchCoupon)(couponCode));
        },
        dispatchClearCoupon: function dispatchClearCoupon() {
            return dispatch((0, _paymentActions.clearCoupon)());
        },
        dispatchResetPayment: function dispatchResetPayment() {
            return dispatch((0, _paymentActions.resetPayment)());
        },
        dispatchFetchUpcomingInvoice: function dispatchFetchUpcomingInvoice(params) {
            return dispatch((0, _paymentActions.fetchUpcomingInvoice)(params));
        },
        dispatchSetProrateDate: function dispatchSetProrateDate(date) {
            return dispatch((0, _paymentActions.setProrateDate)(date));
        }
    };
};

var connectSubmitToProps = function connectSubmitToProps(dispatch, ownProps) {
    return {
        onSubmit: function onSubmit(values) {
            var ownCoupon = ownProps.coupon && ownProps.coupon.get('id');

            // if we have an unsubmitted coupon field, fetch the coupn
            if (values.coupon && (!ownCoupon || values.coupon !== ownCoupon)) {
                return ownProps.dispatchFetchCoupon(values.coupon).then(function (result) {
                    // if the fetched coupon is valid, proceed to submitting the form
                    if ((0, _lodash.get)(result, ['coupon', 'valid'])) return dispatch((0, _paymentActions.submitPaymentForm)(values));
                });
            }

            // if no coupon value, just submit the form
            return dispatch((0, _paymentActions.submitPaymentForm)(values));
        }
    };
};

var Payment = (_dec = (0, _reactRedux.connect)(_paymentSelector.paymentSelector, mapDispatchToProps), _dec2 = (0, _reactRedux.connect)(null, connectSubmitToProps), _dec3 = (0, _milanoteForm2.default)({ form: _paymentConstants.PAYMENT_FORM_NAME, fieldsConfig: _paymentConstants.PAYMENT_FORM_FIELDS }, _paymentSelector.paymentFormValuesSelector), _dec4 = (0, _recompose.withHandlers)({
    handleCouponButtonClick: function handleCouponButtonClick(_ref) {
        var values = _ref.values,
            dispatchFetchCoupon = _ref.dispatchFetchCoupon;
        return function (event) {
            return dispatchFetchCoupon(values.coupon);
        };
    }
}), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = function (_React$Component) {
    _inherits(Payment, _React$Component);

    function Payment() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, Payment);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Payment.__proto__ || Object.getPrototypeOf(Payment)).call.apply(_ref2, [this].concat(args))), _this), _this.checkUpcomingCost = function (nextProps) {
            var currentUser = nextProps.currentUser,
                dispatchFetchUpcomingInvoice = nextProps.dispatchFetchUpcomingInvoice,
                submitting = nextProps.submitting;

            if (submitting) return;
            if (!(0, _userUtil.isSubscribed)(currentUser)) return;

            var prorateDate = (0, _lodash.get)(_this.props, ['values', 'prorateDate']);
            var nextProrateDate = (0, _lodash.get)(nextProps, ['values', 'prorateDate']);
            if (!nextProrateDate) return;

            var interval = (0, _lodash.get)(_this.props, ['values', 'plan']);
            var nextInterval = (0, _lodash.get)(nextProps, ['values', 'plan']);

            var coupon = (0, _lodash.get)(_this.props, 'coupon');
            var nextCoupon = (0, _lodash.get)(nextProps, 'coupon');

            var couponId = coupon && coupon.get('valid') ? coupon.get('id') : undefined;

            var nextCouponId = nextCoupon && nextCoupon.get('valid') ? nextCoupon.get('id') : undefined;

            if (interval === nextInterval && couponId === nextCouponId && prorateDate === nextProrateDate) return;

            dispatchFetchUpcomingInvoice({
                subscriptionId: currentUser.get('subscriptionId'),
                customerId: currentUser.get('customerId'),
                planInterval: nextInterval,
                planVolume: 1,
                coupon: nextCouponId,
                prorateDate: nextProrateDate
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Payment, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                dispatchLoadPlans = _props.dispatchLoadPlans,
                planVolume = _props.planVolume,
                plans = _props.plans,
                dispatchSetProrateDate = _props.dispatchSetProrateDate;


            (0, _planEnquiryAnalyticsService.individualPlanEnquiryAnalytics)();
            dispatchSetProrateDate((0, _timeUtil.getTimestampSeconds)());

            if (!plans) dispatchLoadPlans(planVolume);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.checkUpcomingCost(nextProps);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'Payment' },
                _react2.default.createElement(_LoadingTransitionDisplay2.default, _extends({}, this.props, {
                    isLoading: this.props.viewState === _paymentConstants.PAYMENT_VIEW_STATES.PROCESSING,
                    isSuccessful: this.props.viewState === _paymentConstants.PAYMENT_VIEW_STATES.SUCCESS,
                    InitialComponent: _PaymentForm2.default,
                    LoadingComponent: _PaymentProcessing2.default,
                    SuccessComponent: _PaymentSuccess2.default }))
            );
        }
    }]);

    return Payment;
}(_react2.default.Component)) || _class) || _class) || _class) || _class);
exports.default = Payment;


Payment.propTypes = {
    planVolume: _propTypes2.default.number,
    viewState: _propTypes2.default.string,
    currentUser: _propTypes2.default.object,
    customer: _propTypes2.default.object,
    coupon: _propTypes2.default.object,
    plans: _propTypes2.default.object,
    subscription: _propTypes2.default.object,
    submitting: _propTypes2.default.bool,
    values: _propTypes2.default.object,

    dispatchLoadPlans: _propTypes2.default.func,
    dispatchFetchCoupon: _propTypes2.default.func,
    dispatchFetchUpcomingInvoice: _propTypes2.default.func,
    dispatchSetProrateDate: _propTypes2.default.func
};


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/payment/Payment.js
// module id = 2057
// module chunks = 0